var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorydust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 140,
    width: 140,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h140v140h-140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 29.407 101.26-16.037 16.04 101.26-101.26 16.038z",
    stroke: "#5bcfea",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.2 5h102.523v102.523h-102.523z",
    stroke: "#5bcfea",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5bcfea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.908 61.492 25.107 34.523h-50.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.108 43.708 27.2 52.307h-54.4zm-46.031 13.905-3.233 1.787.618-3.785-2.616-2.68 3.615-.553 1.616-3.444 1.616 3.444 3.615.552-2.616 2.681.618 3.785zm31.385-16.739-3.233 1.788.617-3.785-2.615-2.681 3.614-.552 1.617-3.444 1.616 3.444 3.614.552-2.615 2.68.617 3.786zm23.015-15.692-3.233 1.787.618-3.785-2.616-2.68 3.615-.553 1.616-3.443 1.616 3.443 3.615.553-2.616 2.68.618 3.785zm-46.03 5.231-3.235 1.787.618-3.785-2.616-2.68 3.615-.553 1.616-3.444 1.617 3.444 3.614.552-2.615 2.681.617 3.785zm55.445 16.738-3.232 1.787.617-3.785-2.615-2.68 3.614-.552 1.616-3.444 1.617 3.444 3.614.552-2.615 2.68.617 3.785z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorydust);
export default __webpack_public_path__ + "static/media/storydust.d707c0f4f51a1ad73c5c54f59d7315a0.svg";
export { ForwardRef as ReactComponent };